import { render } from "./Footer.vue?vue&type=template&id=447680d9&scoped=true&bindings={\"snsItems\":\"data\",\"bottom_menu\":\"data\",\"author\":\"data\",\"date\":\"data\"}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=447680d9&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-447680d9"

export default script